import { useEffect, useState } from "react";
import { FilterSection } from "../../../data-model/filterValues";
import { FilterCreationConfig } from "./filterCreationConfig";
import {
  areFilterDependenciesReady,
  buildFilterData,
} from "./filterDataBuilder";
import { useAlgoliaMultiFacetsData } from "./useAlgoliaMultiFacetsData";
import { useFilterDataSelectors } from "./useFilterDataSelectors";

/**
 * Custom hook that manages all data dependencies and coordinates filter data building
 * Combines selectors, data fetching, and filter building logic
 */
export const useFilterDataDependencies = (
  filterCreationConfig: FilterCreationConfig[],
) => {
  const {
    algoliaMultiFacetsCount,
    algoliaMultiFacetsCountLoading,
    authStatusOptions,
    boOptions,
    providerDetails,
    allProvidersDetails,
  } = useFilterDataSelectors();

  const [filterData, setFilterData] = useState<FilterSection[]>([]);

  // Handle Algolia data fetching
  useAlgoliaMultiFacetsData({
    authStatusOptions: authStatusOptions ?? [],
    boOptions: boOptions ?? [],
    providerDetails: providerDetails,
  });

  // Build filter data when dependencies are ready
  useEffect(() => {
    if (
      areFilterDependenciesReady({
        algoliaMultiFacetsCount,
        authStatusOptions,
        boOptions,
        providerDetails,
        filterCreationConfig: filterCreationConfig,
      })
    ) {
      const newFilterData = buildFilterData({
        algoliaMultiFacetsCount,
        authStatusOptions: authStatusOptions ?? [],
        boOptions: boOptions ?? [],
        allProvidersDetails: allProvidersDetails ?? [],
        filterCreationConfig: filterCreationConfig,
      });
      setFilterData(newFilterData);
    }
  }, [
    algoliaMultiFacetsCount,
    authStatusOptions,
    boOptions,
    providerDetails,
    allProvidersDetails,
  ]);

  return {
    filterData,
    algoliaMultiFacetsCountLoading,
    isDataReady: areFilterDependenciesReady({
      algoliaMultiFacetsCount,
      authStatusOptions,
      boOptions,
      providerDetails,
      filterCreationConfig: filterCreationConfig,
    }),
  };
};
